<template>
  <div class="form-floating text-dark my-3 border rounded">
    <input
      v-model="workingModel"
      type="date"
      class="form-control"
      :disabled="disabled"
    />
    <label for="itemNewName">Fecha Expiración</label>
  </div>
</template>
<script>
export default {
  name: "date-field",
  emits: ["updateField"],
  props: {
    disabled: { default: false },
    model: { default: false },
  },
  data() {
    return {
      workingModel: this.model,
    };
  },
  watch: {
    workingModel: {
      handler: function () {
        this.$emit("updateField", this.workingModel);
      },
    },
  },
};
</script>
